EmailFormPhoneNumberInputView = require "../../common/views/phone_number_input"
EmailFormIntlTextParagraphInputView = require "./text_paragraph_input_view"
EmailFormIntlTextParagraphView = require "./text_paragraph_view"
EmailFormTextLineInputView = require "../../common/views/text_line_input_view"
EmailFormIntlFileInputView = require "./file_input_view"
EmailFormIntlFileInputView = require "./number_input_view"
EmailFormEmailInputView = require "../../common/views/email_input_view"
EmailFormIntlDateTimeInputView = require "./date_time_input"
EmailFormBaseView = require "../base_view"
EmailFormIntlPhoneChannelView = require "./phone_channel_view"
CurrentOrderView = require "../../order_related/current_order_view"
SharedFooterView = require "../../../../../shared/frontend/views/footer/INTL/main_view"
EmailFormIntlDateInputView = require "./date_input_view"
EmailFormIntlDropdownInputView = require "./dropdown_input_view"
EmailFormIntlCheckboxInputView = require "./checkbox_input_view"
EmailFormUserNameInputView = require "./user_name_input_view"
SharedWidgetLayoutView = require "../../../../../shared/frontend/views/widget_layout_veiw"
SupportFlexibleStepThreeTemplate = require '../../../../flexible_step_three.html.mustache'
SupportFlexibleEmailFormObjectsTemplate = require '../../../../flexible_email_form_objects.html.mustache'

class EmailFormIntlMainView extends EmailFormBaseView
  events:
    'click .submit-button': 'onSubmitClick'

  initialize: (options)->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    EmailFormBaseView::initialize.apply(this, arguments)
    @footerContainer = $("#footer-content")
    @template = SupportFlexibleStepThreeTemplate
    @model = options.emailFormModel
    @inputObjects  = @model.getEmailFormInputObjects()
    @emailFormViewFooter = new SharedFooterView
      template: 'support_phone_channel_footer'
      emailUs: @emailUsCallback
      model: @model
    @currentOrderView = new CurrentOrderView({
      hideSelfServiceActions: true
      hideExternalDealNotes: true
      showV2View: false
    })

  render: ->
    SharedWidgetLayoutView.hideWidgets()
    if @isPhonePreferredChannel()
      @contactByPhone()
    else
      @contactByEmail()

  isPhonePreferredChannel: ()->
    @model.isMethodOfContactByPhone() or @model.isMethodOfContactByPhoneWithEmail()

  contactByEmail: ()->
    @hideComponents()
    @renderFlexStepThree()
    @renderInputViews(@inputObjects, "#componentList")
    if evaluate(Groupon.Support.ContentModel.isRefundEligible) && Groupon.Support.currentOrder
      @renderCurrentOrder()
    @renderStepActions()
    @validateEmailForm()

  renderFlexStepThree: ()->
    @$el.html(toHtml(@template, @toHash(), @I18nScope))

  contactByPhone: ->
    @hideComponents()
    @$el.html(toHtml(@template, {}, @I18nScope))
    @renderPhoneChannelView()
    @renderStepActions()
    @renderEmailUsFooter() if @isPhonePreferredChannel()
    @hideSubmitButton()

  emailUsCallback: ->
    @contactByEmail()

  populateRefundParams: (currentOrder, orderDetails) ->
    currentOrder.formattedTotalPrice = orderDetails.formattedTotalPrice
    if currentOrder.groupons?[0]? && orderDetails.groupons?[0]?
      currentOrder.groupons[0].redemptionCode ?= orderDetails.groupons[0].redemptionCode

  renderCurrentOrder: () ->
    currentOrder = Groupon.Support.currentOrder
    unless currentOrder.formattedTotalPrice
      params =
        order: currentOrder
        forceFetchOrderDetails: true
        isRefundEligible: true
      _successCallback = (orderDetails) =>
        if orderDetails
          @populateRefundParams(currentOrder, orderDetails)
      Groupon.Support.OrderModel.getOrderDetails params, _successCallback, ()->
    @currentOrderView.$el.addClass('step-three-order-view')
    @currentOrderView.render()
    @$el.find('.step-three-voucher').append(@currentOrderView.el)

  renderPhoneChannelView: ->
    @phoneChannelView = new EmailFormIntlPhoneChannelView
    @phoneChannelView.render()
    @$el.append @phoneChannelView.el

  removePhoneChannelView: ->
    @phoneChannelView.remove() if @phoneChannelView?

  getViewByObjectType: (obj) ->
    options =
      model: obj
      validateEmailForm: @validateEmailForm
      isFlexibleStepThree: @model.isFlexibleStepThree
      template: SupportFlexibleEmailFormObjectsTemplate

    obj.counter = @getEmailFormObjectCount obj.type
    switch obj.type
      when 'phone_number' then new EmailFormPhoneNumberInputView options
      when 'email_address' then new EmailFormEmailInputView options
      when 'number' then new EmailFormIntlFileInputView options
      when 'text_field_paragraph' then new EmailFormIntlTextParagraphInputView options
      when 'text_paragraph' then new EmailFormIntlTextParagraphView options
      when 'text_field_line' then new EmailFormTextLineInputView options
      when 'attachment' then new EmailFormIntlFileInputView options
      when 'calendar_date' then new EmailFormIntlDateInputView options
      when 'calendar_with_hour_slot' then new EmailFormIntlDateTimeInputView options
      when 'dropdown' then new EmailFormIntlDropdownInputView options
      when 'checkbox' then new EmailFormIntlCheckboxInputView options
      when 'user_name' then new EmailFormUserNameInputView options

  getEmailFormObjectCount: (objectType)->
    if @model.emailFormObjectsCount[objectType]?
      ++@model.emailFormObjectsCount[objectType]

  renderEmailUsFooter:() ->
    if @emailFormViewFooter
      @emailFormViewFooter.render()
      @footerContainer.html(@emailFormViewFooter.el)

  hideSubmitButton: ->
    @$el.find(".submit-button").hide()

  showSubmitButton: ->
    @$el.find(".submit-button").show()

  toHash: ->
    {
      reason                 : @getIssueReason()
      is_order               : Groupon.Support.currentOrder?
      show_reason            : !@model.isDummyCategory
      email_channel          : true
      merchant_name          : getDealMerchantName()
      faqInsteadHelpWizard   : window.faqInsteadHelpWizard
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible
      deal_option_title: Groupon.Support.currentOrder?.dealOption?.title
    }

  getChatParams: () ->
    params =
      issue: @getIssueReason()

  getIssueReason: () ->
    @model.reasonText

module.exports = EmailFormIntlMainView
